<template>
  <li v-if="sensor" class="zone-sensor">
    <div class="sensor-settings-row">
      <div class="sensor-name">{{ sensor.name }}</div>
      <Chip>{{ sensor.mac_address }}</Chip>
      <Button
        severity="contrast"
        icon=""
        outlined
        aria-label="Remove sensor"
        @click="removeSensor()"
      >
        <IconRemove />
      </Button>
    </div>

    <div class="sensor-settings-row">
      <FloatLabel variant="on">
        <label>Engaged *</label>
        <Select
          v-model="sensor.engaged_signal"
          :options="usableDistance"
          optionValue="signal_strength"
          optionLabel="distance_text"
        />
      </FloatLabel>

      <FloatLabel variant="on">
        <label>Passerby *</label>
        <Select
          v-model="sensor.passerby_signal"
          :options="passerMinDist"
          optionValue="signal_strength"
          optionLabel="distance_text"
        />
      </FloatLabel>

    </div>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { SensorType, SensorDistanceSettingType } from '@/types/Sensor';

import { Button, FloatLabel, Select } from 'primevue';

import Chip from '@/components/global/Chip.vue';
import Tooltip from '@/components/global/Tooltip.vue';

import IconRemove from '@/icons/IconRemove.svg?component';

import { useUserStore } from '@/stores/user';
const userStore = useUserStore();

const sensor = defineModel<SensorType>('sensor');

const props = defineProps<{
  sensorDistanceOptions: SensorDistanceSettingType[]
}>();

const emit = defineEmits(['removeSensor']);

const removeSensor = () => {
  emit('removeSensor');
}

const usableDistance = computed(() => {
  if (userStore.isNonStaff) {
    return props.sensorDistanceOptions.filter(dist => {
      return Math.floor(dist.distance_metres) <= 43;
    });
  }
  return props.sensorDistanceOptions;
});

const passerMinDist = computed(() => {
  if (sensor.value && sensor.value.engaged_signal) {
    return usableDistance.value.filter(dist => {
      if (sensor.value?.engaged_signal) {
        return dist.signal_strength <= (sensor.value.engaged_signal || 0);
      }
    });
  }

  return props.sensorDistanceOptions;
});

const totalDistance = computed(() => {
  const maxDistance = props.sensorDistanceOptions.find(dist => Math.floor(dist.distance_metres) === 61);
  return maxDistance?.signal_strength || null;
});

</script>
